import { createAction } from '@reduxjs/toolkit';

export const downloadProductsRequest = createAction('products/DOWNLOAD_PRODUCTS_REQUEST');
/** Disparado al finalizar el worker (éxito o error) para liberar el estado de carga en la UI */
export const downloadProductsSettled = createAction('products/DOWNLOAD_PRODUCTS_SETTLED');

export const uploadProductsListRequest = createAction('products/UPLOAD_PRODUCTS_LIST_REQUEST');
export const uploadProductsListSettled = createAction('products/UPLOAD_PRODUCTS_LIST_SETTLED');